import { render, staticRenderFns } from "./AppPageLayout.vue?vue&type=template&id=b3ee13c2&scoped=true"
import script from "./AppPageLayout.vue?vue&type=script&lang=js"
export * from "./AppPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ee13c2",
  null
  
)

export default component.exports